import {
  TAPPING_DAMAGE_FAILED,
  TAPPING_DAMAGE_REQUEST,
  TAPPING_DAMAGE_SUCCESS,
} from "../../../../actions/Factory/Tapping/tappingDamage/constant";

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const tappingDamageReducer = function (state = INIT_STATE, action) {
  switch (action?.type) {
    case TAPPING_DAMAGE_REQUEST:
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };
    case TAPPING_DAMAGE_SUCCESS:
      return {
        loading: false,
        data: action?.payload?.data,
        totalPage: action?.payload?.totalPage,
        error: {
          isError: false,
          message: null,
        },
      };
    case TAPPING_DAMAGE_FAILED:
      const { isError = true, message = "Something Went Wrong" } =
        action?.payload?.error || {};
      return {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError: isError,
          message: message,
        },
      };
    default:
      return state;
  }
};
